import { Col, Form, Row } from 'react-bootstrap';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';

function FamilyDetails({ formData, setFormData, handleChange} ) {

       const [error, setError] = useState('');

       const token =
       typeof window !== "undefined" ? localStorage.getItem("token") : null;

    return (
        <>
            <Form>
                <Form.Label style={{ color: "#6e48aa", fontWeight: "600", borderBottom: "1px solid #6e48aa" }} className='mb-3'>Family Details</Form.Label>
                <Row>
                    <Col xl={3} lg={3} md={3} xs={12} s={12}>
                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Father Name (First & last only)<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Enter Father Name"
                                 id="fatherName"
                                 name='fatherName'
                                 required
                                 value={formData?.fatherName}
                                 onChange={(e) => handleChange('', 'fatherName', e.target.value)} />
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Total Family Members<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Enter Total Family Members"
                                  id="totalFamilyMember"
                                  name='totalFamilyMember'
                                  required value={formData?.totalFamilyMember}
                                  onChange={(e) => handleChange('', 'totalFamilyMember', e.target.value)}/>
                            </Form.Group>
                        </Row>
                    </Col>
                    <Col xl={3} lg={3} md={3} xs={12} s={12}>
                        <Row className='mb-2'>
                            <Form.Group className="mb-2" >
                                <Form.Label>Father Name Unicode (First & Last Only)<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Enter Father Name Unicode"
                                 id="fatherNameUnicode"
                                 name='fatherNameUnicode'
                                 required value={formData?.fatherNameUnicode}
                                 onChange={(e) => handleChange('', 'fatherNameUnicode', e.target.value)} />
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2">
                                <Form.Label>Family Annual Income<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Enter Family Annual Income"
                                 id="familyAnnualIncome"
                                 name='familyAnnualIncome'
                                 required value={formData?.familyAnnualIncome}
                                 onChange={(e) => handleChange('', 'familyAnnualIncome', e.target.value)} />
                            </Form.Group>
                        </Row>
                    </Col>
                    <Col xl={3} lg={3} md={3} xs={12} s={12}>
                        <Row className='mb-2'>
                            <Form.Group className="mb-2" >
                                <Form.Label>Mother Name (First Only)<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Enter Mother Name"
                                 id="MotherName"
                                 name='MotherName'
                                 required value={formData?.MotherName}
                                 onChange={(e) => handleChange('', 'MotherName', e.target.value)} />
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2" >
                                <Form.Label>Parent Name (First & Last Only)</Form.Label>
                                <Form.Control type="text" placeholder="Enter Parent Name"
                                 id="ParentName"
                                 name='ParentName'
                                 required value={formData?.ParentName}
                                 onChange={(e) => handleChange('', 'ParentName', e.target.value)} />
                            </Form.Group>
                        </Row>
                    </Col>
                    <Col xl={3} lg={3} md={3} xs={12} s={12}>
                        <Row className='mb-2'>
                            <Form.Group className="mb-2" >
                                <Form.Label>Mother Name Unicode (First Only)<span className="text-danger">*</span></Form.Label>
                                <Form.Control type="text" placeholder="Enter Mother Name Unicode" 
                                 id="motherNameUnicode"
                                 name='motherNameUnicode'
                                 required value={formData?.motherNameUnicode}
                                 onChange={(e) => handleChange('', 'motherNameUnicode', e.target.value)}/>
                            </Form.Group>
                        </Row>

                        <Row className='mb-2'>
                            <Form.Group className="mb-2" >
                                <Form.Label>Parent Mobile No.</Form.Label>
                                <Form.Control type="text" placeholder="Enter Parent Mobile NO."
                                 id="parentMobile"
                                 name='parentMobile'
                                 required value={formData?.parentMobile}
                                 onChange={(e) => handleChange('', 'parentMobile', e.target.value)} />
                            </Form.Group>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </>

    );
};

FamilyDetails.propTypes = {
    formData: PropTypes.shape({
        fatherName: PropTypes.string,
        totalFamilyMember: PropTypes.string,
        fatherNameUnicode: PropTypes.string,
        familyAnnualIncome: PropTypes.string,
        MotherName: PropTypes.string,
        motherNameUnicode: PropTypes.string,
        parentMobile: PropTypes.string,
        ParentName: PropTypes.string,
    }).isRequired,
    setFormData: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
};

export default FamilyDetails;